export const Voucher = () => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_867_1603"
        maskUnits="userSpaceOnUse"
        x="-0.21875"
        y="1.91748"
        width="32"
        height="20"
        fill="black"
      >
        <rect fill="white" x="-0.21875" y="1.91748" width="32" height="20" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.21915 5.62044C2.21915 4.67992 2.98159 3.91748 3.92211 3.91748H8.58332C9.01598 3.91748 9.3944 4.18205 9.69493 4.4933C10.1079 4.92098 10.6873 5.18697 11.3289 5.18697C11.9705 5.18697 12.5499 4.92098 12.9629 4.4933C13.2634 4.18205 13.6418 3.91748 14.0745 3.91748H28.0783C29.0188 3.91748 29.7812 4.67992 29.7812 5.62044V18.3794C29.7812 19.3199 29.0188 20.0824 28.0783 20.0824L14.0753 20.0824C13.6424 20.0824 13.2639 19.8176 12.9633 19.5061C12.5503 19.0782 11.9707 18.812 11.3289 18.812C10.6871 18.812 10.1075 19.0782 9.69448 19.5061C9.39392 19.8176 9.01538 20.0824 8.58255 20.0824H3.9221C2.98159 20.0824 2.21915 19.3199 2.21915 18.3794V5.62044Z"
        />
      </mask>
      <path
        d="M28.0783 20.0824V18.5824H28.0783L28.0783 20.0824ZM9.69448 19.5061L10.7738 20.5478L9.69448 19.5061ZM9.69493 4.4933L8.61586 5.53522L9.69493 4.4933ZM3.92211 2.41748C2.15316 2.41748 0.719147 3.85149 0.719147 5.62044H3.71915C3.71915 5.50835 3.81001 5.41748 3.92211 5.41748V2.41748ZM8.58332 2.41748H3.92211V5.41748H8.58332V2.41748ZM11.3289 3.68697C11.1107 3.68697 10.9159 3.59838 10.774 3.45138L8.61586 5.53522C9.29983 6.24359 10.2639 6.68697 11.3289 6.68697V3.68697ZM11.8838 3.45138C11.7419 3.59838 11.5471 3.68697 11.3289 3.68697V6.68697C12.3939 6.68697 13.358 6.24359 14.042 5.53522L11.8838 3.45138ZM28.0783 2.41748H14.0745V5.41748H28.0783V2.41748ZM31.2812 5.62044C31.2812 3.8515 29.8472 2.41748 28.0783 2.41748V5.41748C28.1904 5.41748 28.2812 5.50835 28.2812 5.62044H31.2812ZM31.2812 18.3794V5.62044H28.2812V18.3794H31.2812ZM28.0783 21.5824C29.8472 21.5824 31.2812 20.1484 31.2812 18.3794H28.2812C28.2812 18.4915 28.1904 18.5824 28.0783 18.5824V21.5824ZM14.0753 21.5824L28.0783 21.5824L28.0783 18.5824L14.0753 18.5824L14.0753 21.5824ZM11.3289 20.312C11.5472 20.312 11.742 20.4007 11.884 20.5478L14.0427 18.4645C13.3587 17.7557 12.3943 17.312 11.3289 17.312V20.312ZM10.7738 20.5478C10.9158 20.4007 11.1107 20.312 11.3289 20.312V17.312C10.2635 17.312 9.29914 17.7557 8.61512 18.4645L10.7738 20.5478ZM3.9221 21.5824H8.58255V18.5824H3.9221V21.5824ZM0.719147 18.3794C0.719147 20.1484 2.15316 21.5824 3.9221 21.5824V18.5824C3.81002 18.5824 3.71915 18.4915 3.71915 18.3794H0.719147ZM0.719147 5.62044V18.3794H3.71915V5.62044H0.719147ZM8.61512 18.4645C8.57483 18.5063 8.53931 18.5387 8.50933 18.5631C8.47917 18.5876 8.45946 18.5999 8.45097 18.6047C8.4347 18.6139 8.48421 18.5824 8.58255 18.5824V21.5824C9.63347 21.5824 10.3818 20.9541 10.7738 20.5478L8.61512 18.4645ZM14.0753 18.5824C14.1736 18.5824 14.2231 18.6139 14.2068 18.6047C14.1984 18.5999 14.1786 18.5876 14.1485 18.5631C14.1185 18.5387 14.083 18.5063 14.0427 18.4645L11.884 20.5478C12.2761 20.9541 13.0243 21.5824 14.0753 21.5824L14.0753 18.5824ZM14.042 5.53522C14.0822 5.49351 14.1177 5.46108 14.1477 5.43675C14.1779 5.41229 14.1976 5.39997 14.206 5.39519C14.2223 5.38603 14.1728 5.41748 14.0745 5.41748V2.41748C13.024 2.41748 12.2759 3.04531 11.8838 3.45138L14.042 5.53522ZM8.58332 5.41748C8.48502 5.41748 8.43553 5.38603 8.45178 5.39519C8.46025 5.39997 8.47995 5.41229 8.51009 5.43675C8.54007 5.46108 8.57558 5.49351 8.61586 5.53522L10.774 3.45138C10.3819 3.04531 9.63382 2.41748 8.58332 2.41748V5.41748Z"
        fill="black"
        mask="url(#path-1-outside-1_867_1603)"
      />
      <rect
        opacity="0.7"
        x="11.0449"
        y="6.89111"
        width="0.567653"
        height="1.13531"
        rx="0.283827"
        fill="black"
      />
      <rect
        opacity="0.7"
        x="11.0449"
        y="9.16162"
        width="0.567653"
        height="1.13531"
        rx="0.283827"
        fill="black"
      />
      <rect
        opacity="0.7"
        x="11.0449"
        y="11.4324"
        width="0.567653"
        height="1.13531"
        rx="0.283827"
        fill="black"
      />
      <rect
        opacity="0.7"
        x="11.0449"
        y="13.7029"
        width="0.567653"
        height="1.13531"
        rx="0.283827"
        fill="black"
      />
      <rect
        opacity="0.7"
        x="11.0449"
        y="15.9736"
        width="0.567653"
        height="1.13531"
        rx="0.283827"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4181 15.4729L24.4247 7.46631L25.4854 8.52697L17.4788 16.5336L16.4181 15.4729ZM19.9181 8.74658C19.9181 9.71308 19.1346 10.4966 18.1681 10.4966C17.2016 10.4966 16.4181 9.71308 16.4181 8.74658C16.4181 7.78008 17.2016 6.99658 18.1681 6.99658C19.1346 6.99658 19.9181 7.78008 19.9181 8.74658ZM23.7354 17.0032C24.7018 17.0032 25.4854 16.2197 25.4854 15.2532C25.4854 14.2867 24.7018 13.5032 23.7354 13.5032C22.7689 13.5032 21.9854 14.2867 21.9854 15.2532C21.9854 16.2197 22.7689 17.0032 23.7354 17.0032Z"
        fill="currentColor"
      />
      <rect
        opacity="0.7"
        width="0.864693"
        height="4.02991"
        rx="0.432347"
        transform="matrix(0 -1 -1 0 8.8916 8.4502)"
        fill="currentColor"
      />
      <rect
        opacity="0.7"
        width="0.864694"
        height="2.9992"
        rx="0.432347"
        transform="matrix(0 -1 -1 0 7.86133 11.1055)"
        fill="currentColor"
      />
      <rect
        opacity="0.7"
        width="0.864694"
        height="3.62388"
        rx="0.432347"
        transform="matrix(0 -1 -1 0 8.48535 13.7598)"
        fill="currentColor"
      />
      <rect
        opacity="0.7"
        width="0.864694"
        height="1.49988"
        rx="0.432347"
        transform="matrix(0 -1 -1 0 6.36133 16.415)"
        fill="currentColor"
      />
    </svg>
  )
}
